import Events from "@/src/screens/events/events";

export default function EventsScreen() {
  return <Events />;
}
